export const environment = {
  production: true,
  buildId: '2511846342517421',
  configFile: 'config.json',
};
